// --- Reusable Card Component ---
const InsightCard = ({ item }) => (
  <div className="bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 group">
    {/* Image Wrapper */}
    <div className="h-48 overflow-hidden relative">
      <img
        src={item.image}
        alt={item.title}
        className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
      />
      {/* Category Badge on Image */}
      <span
        className={`absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider ${item.catColor} shadow-sm`}
      >
        {item.category}
      </span>
    </div>

    {/* Content */}
    <div className="p-6">
      <div className="text-xs text-slate-400 font-medium mb-2 flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-slate-300"></span>
        {item.date}
      </div>
      <h3 className="text-xl font-bold mb-3 text-slate-900 leading-tight group-hover:text-blue-600 transition-colors">
        {item.title}
      </h3>
      <p className="text-slate-600 text-sm leading-relaxed line-clamp-3">
        {item.desc}
      </p>
    </div>
  </div>
);

// Data for the insights (You can add more to this array)
const insights = [
  {
    id: 1,
    category: "Career",
    catColor: "bg-blue-100 text-blue-600",
    date: "Oct 24, 2023",
    title: "We are Hiring: Senior UI/UX Designer",
    desc: "Join our creative team to build the next generation of interfaces. Apply now!",
    image:
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
  },
  {
    id: 2,
    category: "Mobile",
    catColor: "bg-blue-500 text-white",
    date: "Oct 20, 2023",
    title: "Why Flutter is the Future of 2024",
    desc: "Our technical lead explores the benefits of cross-platform development.",
    image:
      "https://images.unsplash.com/photo-1555421689-491a97ff2040?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
  },
  {
    id: 3,
    category: "Web",
    catColor: "bg-emerald-100 text-emerald-600",
    date: "Oct 15, 2023",
    title: "Optimizing React Performance",
    desc: "Tips and tricks to make your React web apps run at 60fps.",
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
  },
];

const TechInsightsSection = () => {
  return (
    <section className="py-24 bg-slate-50 text-slate-800">
      <div className="container mx-auto px-6 max-w-screen-xl">
        {/* --- Section Header --- */}
        <div className="text-center max-w-2xl mx-auto mb-20">
          <span className="text-blue-600 font-bold tracking-wider uppercase text-xs">
            Knowledge Hub
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mt-2 mb-4 text-slate-900">
            Latest Tech Insights
          </h2>
          <p className="text-slate-600">
            Stay ahead of the curve with our expert analysis on technology,
            design, and company culture.
          </p>
        </div>

        {/* --- Grid Layout --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {insights.map((item) => (
            <InsightCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechInsightsSection;
